<template>
  <div class="dashboard-indicadores-historico">
    <app-ventas-total
      ref="ventasTotales"
      :totalNegocio="true">
    </app-ventas-total>

    <app-ventas
      ref="ventas">
    </app-ventas>

    <app-ventas-anual-total
      ref="ventasAnualTotales"
      :totalNegocio="true">
    </app-ventas-anual-total>

    <app-ventas-anual
      ref="ventasAnual">
    </app-ventas-anual>

    <app-ventas-mix-clientes-semestral-total
      ref="ventasMixClientesSemestralTotal"
      :totalNegocio="true"
      :semestral="true">
    </app-ventas-mix-clientes-semestral-total>

    <app-ventas-mix-clientes-semestral
      ref="ventasMixClientesSemestral"
      :semestral="true">
    </app-ventas-mix-clientes-semestral>

    <app-ventas-mix-clientes-anual-total
      ref="ventasMixClientesAnualTotal"
      :totalNegocio="true"
      :semestral="false">
    </app-ventas-mix-clientes-anual-total>

    <app-ventas-mix-clientes-anual
      ref="ventasMixClientesAnual"
      :semestral="false">
    </app-ventas-mix-clientes-anual>

    <app-objetivos-mensuales
      ref="objetivosMensuales">
    </app-objetivos-mensuales>

    <app-rentabilidad-neta-semestral-total
      ref="rentabilidadNetaSemestralTotal"
      :semestral="true"
      :totalNegocio="true">
    </app-rentabilidad-neta-semestral-total>

    <app-rentabilidad-neta-semestral
      ref="rentabilidadNetaSemestral"
      :semestral="true">
    </app-rentabilidad-neta-semestral>

    <app-rentabilidad-neta-anual-total
      ref="rentabilidadNetaAnualTotal"
      :semestral="false"
      :totalNegocio="true">
    </app-rentabilidad-neta-anual-total>

    <app-rentabilidad-neta-anual
      ref="rentabilidadNetaAnual"
      :semestral="false">
    </app-rentabilidad-neta-anual>

    <app-diferencia-plazos
      ref="diferenciaPlazos">
    </app-diferencia-plazos>

    <app-plazos-proveedores-semestral
      ref="plazosSemestral"
      :semestral="true">
    </app-plazos-proveedores-semestral>

    <app-plazos-proveedores-anual
      ref="plazosAnual"
      :semestral="false">
    </app-plazos-proveedores-anual>

    <app-plazos-clientes
      ref="plazosClientes">
    </app-plazos-clientes>
  </div>
</template>

<script>
import Ventas from './IndicadoresHistoricoVentas';
import VentasTotal from './IndicadoresHistoricoVentas';
import VentasAnual from './IndicadoresHistoricoVentasAnual';
import VentasAnualTotal from './IndicadoresHistoricoVentasAnual';
import VentasMixClientesSemestral from './IndicadoresHistoricoVentasMixClientes';
import VentasMixClientesSemestralTotal from './IndicadoresHistoricoVentasMixClientes';
import VentasMixClientesAnual from './IndicadoresHistoricoVentasMixClientes';
import VentasMixClientesAnualTotal from './IndicadoresHistoricoVentasMixClientes';
import RentabilidadNetaSemestral from './IndicadoresHistoricoRentabilidadNeta';
import RentabilidadNetaSemestralTotal from './IndicadoresHistoricoRentabilidadNeta';
import RentabilidadNetaAnual from './IndicadoresHistoricoRentabilidadNeta';
import RentabilidadNetaAnualTotal from './IndicadoresHistoricoRentabilidadNeta';
import DiferenciaPlazos from './IndicadoresHistoricoDiferenciaPlazos';
import PlazosProveedoresSemestral from './IndicadoresHistoricoPlazosProveedores';
import PlazosProveedoresAnual from './IndicadoresHistoricoPlazosProveedores';
import PlazosClientes from './IndicadoresHistoricoPlazosClientes';
import ObjetivosMensualesHistoricos from './historicos/ObjetivosMensualesHistoricos';

export default {
  components: {
    appVentas: Ventas,
    appVentasTotal: VentasTotal,
    appVentasAnual: VentasAnual,
    appVentasAnualTotal: VentasAnualTotal,
    appVentasMixClientesSemestral: VentasMixClientesSemestral,
    appVentasMixClientesSemestralTotal: VentasMixClientesSemestralTotal,
    appVentasMixClientesAnual: VentasMixClientesAnual,
    appVentasMixClientesAnualTotal: VentasMixClientesAnualTotal,
    appRentabilidadNetaSemestral: RentabilidadNetaSemestral,
    appRentabilidadNetaSemestralTotal: RentabilidadNetaSemestralTotal,
    appRentabilidadNetaAnual: RentabilidadNetaAnual,
    appRentabilidadNetaAnualTotal: RentabilidadNetaAnualTotal,
    appDiferenciaPlazos: DiferenciaPlazos,
    appPlazosProveedoresSemestral: PlazosProveedoresSemestral,
    appPlazosProveedoresAnual: PlazosProveedoresAnual,
    appPlazosClientes: PlazosClientes,
    appObjetivosMensuales: ObjetivosMensualesHistoricos,
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    getIndicadores() {
      this.$store.dispatch('resultadosVentas/inicializarVentasHistorico')
        .then(() => {
          this.$refs.ventas.getIndicadores();
          this.$refs.ventasTotales.getIndicadores();
          this.$refs.ventasAnual.getIndicadores();
          this.$refs.ventasAnualTotales.getIndicadores();
          this.$refs.ventasMixClientesSemestral.getIndicadores();
          this.$refs.ventasMixClientesSemestralTotal.getIndicadores();
          this.$refs.ventasMixClientesAnual.getIndicadores();
          this.$refs.ventasMixClientesAnualTotal.getIndicadores();
        })
      
      this.$store.dispatch('resultadosRentabilidadNeta/inicializarHistorico')
        .then(() => {
          this.$refs.rentabilidadNetaSemestral.getIndicadores();
          this.$refs.rentabilidadNetaSemestralTotal.getIndicadores();
          this.$refs.rentabilidadNetaAnual.getIndicadores();
          this.$refs.rentabilidadNetaAnualTotal.getIndicadores();
        })

      this.$store.dispatch('resultadosIndicadores/inicializarHistorico')
        .then(() => {
          this.$refs.diferenciaPlazos.getIndicadores();
          this.$refs.plazosSemestral.getIndicadores();
          this.$refs.plazosAnual.getIndicadores();
        })
        
      this.$store.dispatch('resultadosAdministracion/inicializarHistorico')
        .then(() => {
          this.$refs.plazosClientes.getIndicadores();
        })
        
      this.$store.dispatch('resultadosComercial/inicializarHistorico')
        .then(() => {
          this.$refs.objetivosMensuales.getResultados();
        })
    }
  }
}
</script>

<style>
  .dashboard-indicadores-historico .row {
    margin-bottom: 30px;
  }

  .dashboard-indicadores-historico .titulo {
    color: #23282c;
    font-size: 0.8em;
    font-weight: 700;
    margin-left: 10px;
  }

  .dashboard-indicadores-historico table thead th {
    border-top: none;
  }

  .dashboard-indicadores-historico .registro table td[aria-colindex="1"],
  .dashboard-indicadores-historico .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .dashboard-indicadores-historico .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico .registro table td[aria-colindex="4"] {
    width: 20%;
  }
  .dashboard-indicadores-historico .registro table td[aria-colindex="5"] {
    width: 40%;
  }
</style>